import {styled} from "@mui/material/styles";
import {Link} from "react-router";

export const LocationItemLinkRoot = styled(Link)(() => ({
  textAlign: 'inherit',
  width: "100%",
  '&:link': {
    color: 'unset',
    textDecoration: 'none',
  },
  '&:visited': {
    color: 'unset',
    textDecoration: 'none',
  },
  '&:focus': {
    color: 'unset',
    textDecoration: 'none',
  },
  '&:hover': {
    color: 'unset',
    textDecoration: 'none',
  },
  '&:active': {
    color: 'unset',
    textDecoration: 'none',
  },
}));

/**
 * Non-navigating counterpart to {@link LocationItemLinkRoot}. Used for offline
 * (`live=false`) locations where the card must render without an href so the
 * buyer cannot navigate to an unavailable location profile.
 */
export const LocationItemNonLinkRoot = styled('div')(() => ({
  textAlign: 'inherit',
  width: '100%',
  color: 'unset',
  textDecoration: 'none',
  cursor: 'default',
}));
